import { InfoOutlined } from "@material-ui/icons";
import {
  Box,
  IconButton,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";
import {
  ANSWERED_DURATION_OPTION,
  LIST_INBOUND_CALL_STATUS_V2,
  TYPE_PBX_OPTIONS,
} from "constant";
import moment from "moment";
import { useGetExtensionDetail } from "service/query/extension.query";

const DetailOutboundCallExportHistories = ({ record }) => {
  const result = [];
  const { data: extension } = useGetExtensionDetail(record?.filter?.extensions);

  const extensionName = record.filter.extensions
    ? `${extension?.name} - ${extension?.username}`
    : null;
  const statusCall = record?.filter?.status
    ? LIST_INBOUND_CALL_STATUS_V2.find(
        (item) => item.value === record?.filter?.status
      )?.label
    : null;
  const answeredDurationLabel = record?.filter?.answeredDuration
    ? ANSWERED_DURATION_OPTION.find(
        (item) => item.value === record?.filter?.answeredDuration
      )?.label
    : null;
  const typePbxLabel = record?.filter?.typePbx
    ? TYPE_PBX_OPTIONS.find((item) => item.value === record?.filter?.typePbx)
        ?.label
    : null;
  const fromTime = moment(record.filter.from).format("YYYY-MM-DD HH:mm");
  const endTime = moment(record.filter.to).format("YYYY-MM-DD HH:mm");
  result.push(`Thời gian: ${fromTime} - ${endTime}`);
  result.push(`Số điện thoại gọi ra: ${record.filter.fromNumber ?? "Tất cả"}`);
  result.push(`Số hiệu bưu gửi: ${record.filter.ladingCode ?? "Tất cả"}`);
  record?.filter?.cityName &&
    result.push(
      `Bưu điện tỉnh/thành phố: ${record.filter.cityName ?? "Tất cả"}`
    );
  record?.filter?.districtName &&
    result.push(`Bưu điện huyện: ${record.filter.districtName ?? "Tất cả"}`);
  record?.filter?.subOrgName &&
    result.push(`Bưu cục: ${record.filter.subOrgName ?? "Tất cả"}`);
  result.push(`Loại tổng đài: ${typePbxLabel ?? "Tất cả"}`);
  result.push(
    `Số điện thoại nhận cuộc gọi: ${record.filter.toNumber ?? "Tất cả"}`
  );
  result.push(`Trạng thái cuộc gọi: ${statusCall ?? "Tất cả"}`);
  result.push(`Máy lẻ: ${extensionName ?? "Tất cả"}`);
  result.push(`Thời lượng gọi: ${answeredDurationLabel ?? "Tất cả"}`);

  return (
    <Tooltip
      PopperProps={{
        sx: {
          [`& .${tooltipClasses.tooltip}`]: {
            maxWidth: 500,
          },
        },
      }}
      placement="left"
      title={
        <Box sx={{ fontSize: 14 }}>
          {result.map((item, index) => (
            <Typography key={index}>{item}</Typography>
          ))}
        </Box>
      }>
      <IconButton color="default">
        <InfoOutlined />
      </IconButton>
    </Tooltip>
  );
};

export default DetailOutboundCallExportHistories;
